import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: [], // Store the entire API response here
};

const KycsSlice = createSlice({
  name: "kycs_details",
  initialState,
  reducers: {
    Kycsdetails: (state, action) => {
      state.data = action.payload; // Store the entire API response
    },
  },
});

export const { Kycsdetails } = KycsSlice.actions;
export default KycsSlice.reducer;